import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import StructuredData from '../../components/base/StructuredData';
import HeroSection from './components/HeroSection';
import TrustCounters from './components/TrustCounters';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import ServiceAreaSection from './components/ServiceAreaSection';
import TestimonialsSection from './components/TestimonialsSection';
import FinalCTA from './components/FinalCTA';

const HomePage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'JUSTCLEAN Mollet del Vallès',
    image: 'https://public.readdy.ai/ai/img_res/e56dcec8-9449-48d5-b8a7-6a7b9cfe19ca.png',
    '@id': 'https://mollet.justclean.es',
    url: 'https://mollet.justclean.es',
    telephone: '+34602365996',
    email: 'info@mollet.justclean.es',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Carrer de Barcelona, 45',
      addressLocality: 'Mollet del Vallès',
      postalCode: '08100',
      addressRegion: 'Barcelona',
      addressCountry: 'ES',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 41.5397,
      longitude: 2.2133,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '20:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '09:00',
        closes: '14:00',
      },
    ],
    areaServed: [
      'Mollet del Vallès',
      'Parets del Vallès',
      'Montmeló',
      'Montornès del Vallès',
      'La Llagosta',
      'Martorelles',
      'Granollers',
      'Santa Perpètua de Mogoda',
    ],
    priceRange: '$$',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Servicios de Vaciado y Limpieza',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Vaciado de Pisos y Casas',
            description: 'Servicio profesional de vaciado completo de pisos y casas en Mollet del Vallès',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Vaciado de Locales Comerciales',
            description: 'Vaciado de locales comerciales, oficinas y naves industriales',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Retirada de Muebles y Electrodomésticos',
            description: 'Retirada y gestión de residuos de muebles y electrodomésticos',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Limpieza por Síndrome de Diógenes',
            description: 'Servicio especializado y discreto para casos de síndrome de Diógenes y suciedad extrema',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Pintura Final',
            description: 'Servicio de pintura para dejar el espacio listo para alquilar o vender',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Pequeñas Reparaciones',
            description: 'Reparaciones menores para entrega de llaves',
          },
        },
      ],
    },
  };

  return (
    <div className={`min-h-screen transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <StructuredData data={structuredData} />
      <Header />
      <main>
        <HeroSection />
        <TrustCounters />
        <ServicesSection />
        <ProcessSection />
        <ServiceAreaSection />
        <TestimonialsSection />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
};

export default HomePage;